import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { ResponseGridDataProviderFactory } from '../factory/ResponseGridDataProviderFactory';
import { ResponseGridViewDataProvider } from '../dataProvider/ResponseGridViewDataProvider';
import { CustomRuleDetails, ResponseGridViewData, Status } from '../types';

export class ResponseGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ResponseGridDataProviderFactory;
  public dataProvider: ResponseGridViewDataProvider;

  public constructor() {
    super();

    this.initialSetup({
      dataProviderFactory: new ResponseGridDataProviderFactory(),
    });
  }

  public getDataForView(incidentId: string): ResponseGridViewData {
    return this.dataProvider.getDataForView(incidentId);
  }

  public async updateStatus(id: string, status: Status): Promise<void> {
    await this.dataProvider.updateStatus(id, status);
  }

  public getCustomRuleDetails(id: string): Promise<CustomRuleDetails> {
    return this.dataProvider.getCustomRuleDetails(id);
  }
}
